import { Outlet } from 'react-router-dom';

function AccountAndSettingsBasePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default AccountAndSettingsBasePage;
